import React, { useEffect, useState, useRef } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { useDispatch } from 'react-redux'
import * as auth from '../redux/AuthRedux'
import { Link, useNavigate, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toAbsoluteUrl } from "../../../../_jutemplate/helpers/AssetHelpers";
import { OTPInput } from "../../../components/user-input/OTPInput";
import { OTPLogin } from "../redux/AuthCRUD";
import {
  userSuccessFeedback,
  userErrorFeedback,
} from "../../../..//app/utility/user-feedback-config";

export const OPTCode = () => {

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(300); // Set OTP expiry time (300 seconds for 5 minutes)
  const [otp, setOtp] = useState<number|null>(null);
  const otpLength = 4
  const location: any = useLocation();
  const navigate = useNavigate()

  const { unique_id } = location?.state || {}; // Access passed data

  const handleOtpChange = (otp: any) => {
    setOtp(otp)
  };
  
  console.log(otp)

  useEffect(() => {
    let interval: any;
    if (seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
      navigate('/auth')
    }
    return () => clearInterval(interval);
  }, [seconds])

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await OTPLogin(unique_id, otp);
      let token = response?.data?.data?.token
      dispatch(auth.actions.login(token))
      userSuccessFeedback(response.data?.message);
    } catch (error: any) {
      if (error.response) {
        // console.log(error.response)
        const message = error.response.data?.message || "Server Error";
        userErrorFeedback(message);
      } else {
        const message = error?.message || "Unknown Error";
        userErrorFeedback(message);
      }
      return null;
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    if (!unique_id) {
      navigate('/auth')
    }
  }, [])

  return (
    <>



      {/* begin :: Heading */}
      <div className="d-flex flex-column align-items-center ">
        <img
          alt="Logo"
          src={toAbsoluteUrl('/media/logos/dr_chashi.png')}
          style={{ width: "200px" }}
        />
        <h2
          className="fw-semibold m-0 mb-2 mt-8"
          style={{ color: "#2F3367", fontSize: "18px" }}
        >
          Verify Now
        </h2>
        <h5
          className="fw-normal m-0"
          style={{ color: "#303468", fontSize: "18px" }}
        >
          We Send OTP To Your Phone
        </h5>
      </div>

      {/* End::Heading */}

      {/* begin::Form group */}
      <form onSubmit={handleSubmit}>
        <div className="d-flex justify-content-center py-10">
          <OTPInput length={otpLength} onChangeOtp={handleOtpChange} />
        </div>

        {/* begin::Action */}

        <button
          type="submit"
          id="kt_sign_in_submit"
          className="loginbtn w-100"
          // disabled={formik.isSubmitting || !formik.isValid}
          disabled={ loading || (otpLength !== otp?.toString().length) }
        >
          {!loading && <span className="indicator-label">Submit</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </form>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <h6 style={{ color: "#303468", fontSize: "14px" }}>{`OTP Invalid After : ${minutes}:${secs < 10 ? '0' : ''}${secs} seconds`}</h6>
      </div>
      {/* end::Form group */}
      <div className="d-flex justify-content-end mt-5">
        <Link to="/login" className="ps-3 forgotpassword-link">
          Back to Login
        </Link>
      </div>



    </>

  )
}

